import { render } from "./MultiCheckboxComponent.vue?vue&type=template&id=79219c0b&ts=true"
import script from "./MultiCheckboxComponent.vue?vue&type=script&lang=ts"
export * from "./MultiCheckboxComponent.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/atlassian/pipelines/agent/build/SurveyPublic/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__